(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bloosh-fall-waitlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bloosh-fall-waitlist')) {
    const POPULAR_DOMAINS = ['gmail.com', 'wp.pl', 'o2.pl', 'onet.pl', 'interia.pl', 'op.pl', 'poczta.onet.pl', 'icloud.com', 'outlook.com', 'hotmail.com', 'yahoo.com', 'live.com', 'tlen.pl', 'gazeta.pl', 'vp.pl'];
    // Real mailboxes within two edits of a popular domain; "correcting" them would lose the lead.
    const VALID_DOMAINS = new Set([...POPULAR_DOMAINS, 'go2.pl', 'onet.eu', 'poczta.onet.eu', 'interia.eu', 'wp.eu', 'ymail.com', 'mail.com', 'tlen.eu', 'o2.eu']);
    const firstLabel = (domain) => domain.split('.')[0];
    const editDistance = (a, b) => {
      let row = Array.from({ length: b.length + 1 }, (_, j) => j);
      for (let i = 1; i <= a.length; i++) {
        const next = [i];
        for (let j = 1; j <= b.length; j++)
          next[j] = Math.min(row[j] + 1, next[j - 1] + 1, row[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        row = next;
      }
      return row[b.length];
    };
    const suggestEmail = (email) => {
      const at = email.lastIndexOf('@');
      const domain = email.slice(at + 1).toLowerCase();
      if (at < 1 || VALID_DOMAINS.has(domain)) return null;
      let best = null;
      let bestDistance = 3;
      for (const candidate of POPULAR_DOMAINS) {
        // Two edits span every short .pl name (rp.pl, tvp.pl → wp.pl, vp.pl), so a short name may only differ after its first dot.
        const [typed, target] = [firstLabel(domain), firstLabel(candidate)];
        if ((typed.length <= 3 || target.length <= 3) && typed !== target) continue;
        const distance = editDistance(domain, candidate);
        if (distance < bestDistance) [best, bestDistance] = [candidate, distance];
      }
      return best && email.slice(0, at + 1) + best;
    };

    customElements.define(
      'bloosh-fall-waitlist',
      class BlooshFallWaitlist extends HTMLElement {
        connectedCallback() {
          const form = this.querySelector('form');
          if (!form) return;

          this.form = form;
          this.button = form.querySelector('button[type="submit"]');
          this.status = form.querySelector('[data-sending-status]');
          this.input = form.querySelector('input[type="email"]');
          this.typo = form.querySelector('[data-typo]');
          this.suggested ||= new Set();
          this.handleCheck ||= () => this.suggestFix();
          this.handleInput ||= () => this.typo.replaceChildren();
          this.handlePageShow ||= () => this.resetFeedback();
          this.handleSubmit ||= (event) => {
            this.suggestFix();
            if (!this.form.checkValidity()) return;

            if (this.button) this.button.setAttribute('aria-busy', 'true');
            if (this.status) this.status.hidden = false;
            window.clearTimeout(this.resetTimer);
            this.resetTimer = window.setTimeout(() => this.resetFeedback(), 15000);
            // With Shopify's bot protection on, its own listeners submit natively: a captcha token is
            // single-use, so a fetch followed by a fallback POST would fail the second time.
            if (window.Shopify?.captcha) return;
            event.preventDefault();
            this.send();
          };

          window.addEventListener('pageshow', this.handlePageShow);
          form.addEventListener('submit', this.handleSubmit);
          this.input?.addEventListener('blur', this.handleCheck);
          this.input?.addEventListener('input', this.handleInput);
        }

        disconnectedCallback() {
          window.removeEventListener('pageshow', this.handlePageShow);
          this.form?.removeEventListener('submit', this.handleSubmit);
          this.input?.removeEventListener('blur', this.handleCheck);
          this.input?.removeEventListener('input', this.handleInput);
          this.resetFeedback();
          this.form = null;
          this.button = null;
          this.status = null;
        }

        // Offered once per typed value, so an ignored hint never comes back; never blocks the submit.
        suggestFix() {
          const value = this.input?.value.trim();
          if (!this.typo || this.suggested.has(value)) return;
          const fix = suggestEmail(value);
          if (!fix) return;
          this.suggested.add(value);
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = `Czy chodziło o ${fix}?`;
          button.addEventListener('click', () => {
            this.input.value = fix;
            this.typo.replaceChildren();
            this.button?.focus();
          });
          this.typo.replaceChildren(button);
        }

        // Anything short of a stored sign-up goes through the native POST, so Shopify shows its own
        // bot challenge or form errors. A sign-up redirects to return_to with customer_posted=true.
        async send() {
          const form = this.form;
          let stored = false;
          try {
            const response = await fetch(form.action, {
              method: 'POST',
              body: new URLSearchParams(new FormData(form)),
              credentials: 'same-origin',
            });
            stored =
              response.ok &&
              new URL(response.url).searchParams.get('customer_posted') === 'true' &&
              !(await response.text()).includes(`id="${form.id}-error"`);
          } catch {}
          if (stored) this.showSuccess();
          else HTMLFormElement.prototype.submit.call(form);
        }

        showSuccess() {
          const fields = this.form.querySelector('[data-fields]');
          const message = fields.querySelector('template[data-success]').content.firstElementChild.cloneNode(true);
          this.resetFeedback();
          this.form.querySelector('.bloosh-fall-waitlist__message--error')?.remove();
          fields.replaceWith(message);
          this.querySelector('.bloosh-fall-waitlist__note')?.setAttribute('hidden', '');
          message.focus();
        }

        resetFeedback() {
          window.clearTimeout(this.resetTimer);
          this.resetTimer = null;
          if (this.button) this.button.removeAttribute('aria-busy');
          if (this.status) this.status.hidden = true;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
